import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { EmbedVisualization } from 'client/embed/components/embed-visualization';

export type Props = RouteComponentProps<{
  readonly visId: string;
}>;

export const VisualizationEmbedPage: React.FC<Props> = (props) => {
  const visId = props.match.params.visId;
  return <EmbedVisualization visualizationId={visId} />;
};
